import {put, takeLatest, call} from 'redux-saga/effects';
import * as categoryService from "../../../services/categoryService";
import {
    REORDER_CATEGORIES,
    REORDER_CATEGORIES_SUCCESS,
    REORDER_CATEGORIES_ERROR,
}
    from "../../actions/category";

function* reOrderCategoriesSaga(action) {
    try {
        yield put({
            type: REORDER_CATEGORIES_SUCCESS,
            payload: action.payload
        });
        yield call(categoryService.ReOrderCategories,action.payload)
   


    } catch (error) {
        yield put({
            type: REORDER_CATEGORIES_ERROR,error: error.data
        });
    }
}


export function* reOrderCategoriesSagaWatcher() {
    yield takeLatest(REORDER_CATEGORIES, reOrderCategoriesSaga);
}